import { render, staticRenderFns } from "./filingList.vue?vue&type=template&id=142ab74b&scoped=true"
import script from "./filingList.vue?vue&type=script&lang=js"
export * from "./filingList.vue?vue&type=script&lang=js"
import style0 from "./filingList.vue?vue&type=style&index=0&id=142ab74b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ab74b",
  null
  
)

export default component.exports